import React from 'react';
import Tooltip from '@ingka/tooltip';
import cx from 'classnames';
import styles from './StatusBadges.module.scss';
import SSRIcon from '@ingka/ssr-icon';

export interface BadgeProps {
  className?: string;
  compact?: boolean;
  iconPath?: (prefix?: string) => React.SVGProps<SVGElement>[];
  CustomIcon?: React.ElementType;
  label?: string;
  tooltip?: string;
  labelCompact?: string;
  showTooltip?: boolean;
}

const Badge: React.FC<BadgeProps> = ({
  className,
  compact = false,
  iconPath,
  CustomIcon,
  label = '',
  tooltip,
  labelCompact = '',
  showTooltip = true,
}) => {
  const lbl = compact ? labelCompact : label;

  if (tooltip && showTooltip) {
    return (
      <Tooltip
        describedById={`badge-${label}-tooltip`}
        interactiveCustomTrigger
        tooltipText={tooltip}
        position="trailing"
      >
        <span className={cx(styles.badge, { [styles.compact]: compact }, className)}>
          {!!iconPath && <SSRIcon paths={iconPath} className={styles.icon} />}
          {!!CustomIcon && <CustomIcon className={styles.icon} />}
          {!!lbl && <span className={styles.label}>{lbl}</span>}
        </span>
      </Tooltip>
    );
  }

  return (
    <span className={cx(styles.badge, { [styles.compact]: compact }, className)}>
      {!!iconPath && <SSRIcon paths={iconPath} className={styles.icon} />}
      {!!lbl && <span className={styles.label}>{lbl}</span>}
    </span>
  );
};

export default Badge;
